var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUniversity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H21.5C21.9142 21.25 22.25 21.5858 22.25 22C22.25 22.4142 21.9142 22.75 21.5 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.25C3.41421 12.25 3.75 12.5858 3.75 13V22C3.75 22.4142 3.41421 22.75 3 22.75C2.58579 22.75 2.25 22.4142 2.25 22V13C2.25 12.5858 2.58579 12.25 3 12.25ZM21 12.25C21.4142 12.25 21.75 12.5858 21.75 13V22C21.75 22.4142 21.4142 22.75 21 22.75C20.5858 22.75 20.25 22.4142 20.25 22V13C20.25 12.5858 20.5858 12.25 21 12.25Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.25C7.91421 7.25 8.25 7.58579 8.25 8V22C8.25 22.4142 7.91421 22.75 7.5 22.75C7.08579 22.75 6.75 22.4142 6.75 22V8C6.75 7.58579 7.08579 7.25 7.5 7.25ZM16.5 7.25C16.9142 7.25 17.25 7.58579 17.25 8V22C17.25 22.4142 16.9142 22.75 16.5 22.75C16.0858 22.75 15.75 22.4142 15.75 22V8C15.75 7.58579 16.0858 7.25 16.5 7.25Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 13C1.25 12.5858 1.58579 12.25 2 12.25H7C7.41421 12.25 7.75 12.5858 7.75 13C7.75 13.4142 7.41421 13.75 7 13.75H2C1.58579 13.75 1.25 13.4142 1.25 13ZM16.25 13C16.25 12.5858 16.5858 12.25 17 12.25H22C22.4142 12.25 22.75 12.5858 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75H17C16.5858 13.75 16.25 13.4142 16.25 13Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 8C5.75 7.58579 6.08579 7.25 6.5 7.25H17.5C17.9142 7.25 18.25 7.58579 18.25 8C18.25 8.41421 17.9142 8.75 17.5 8.75H6.5C6.08579 8.75 5.75 8.41421 5.75 8Z",
    fill: "#76B72A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z",
    fill: "#76B72A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11.25C10.9142 11.25 11.25 11.5858 11.25 12V12.5C11.25 12.9142 10.9142 13.25 10.5 13.25C10.0858 13.25 9.75 12.9142 9.75 12.5V12C9.75 11.5858 10.0858 11.25 10.5 11.25ZM13.5 11.25C13.9142 11.25 14.25 11.5858 14.25 12V12.5C14.25 12.9142 13.9142 13.25 13.5 13.25C13.0858 13.25 12.75 12.9142 12.75 12.5V12C12.75 11.5858 13.0858 11.25 13.5 11.25Z",
    fill: "#76B72A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15.25C10.9142 15.25 11.25 15.5858 11.25 16V16.5C11.25 16.9142 10.9142 17.25 10.5 17.25C10.0858 17.25 9.75 16.9142 9.75 16.5V16C9.75 15.5858 10.0858 15.25 10.5 15.25ZM13.5 15.25C13.9142 15.25 14.25 15.5858 14.25 16V16.5C14.25 16.9142 13.9142 17.25 13.5 17.25C13.0858 17.25 12.75 16.9142 12.75 16.5V16C12.75 15.5858 13.0858 15.25 13.5 15.25Z",
    fill: "#76B72A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 2.95801V4.24268H15.25V3.57781L12.75 2.95801ZM12.75 5.74268H16C16.4142 5.74268 16.75 5.40689 16.75 4.99268V2.99105C16.75 2.64635 16.515 2.34603 16.1805 2.26308L12.1938 1.27469C11.7137 1.15566 11.25 1.51906 11.25 2.01214V7.99936C11.25 8.41357 11.5858 8.74936 12 8.74936C12.4142 8.74936 12.75 8.41357 12.75 7.99936V5.74268Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUniversity);
export default __webpack_public_path__ + "static/media/ic-university.9895ccaa793150085e62ea8e836eb01b.svg";
export { ForwardRef as ReactComponent };